export default __webpack_public_path__ + "static/media/money.a66da9b2.svg";